<template>
  <div class="c-advice">
    <div class="c-advice__image">
      <topic-circle
        :label="topic.title"
        :status="status"
        :size="sizeCategory"
        :no-opinion="noOpinion"
        :image="'/images/' + topic.image"
        :static="true"
        :show-halo="true"
      />
    </div>
    <div class="c-advice__text">
      <h2 class="c-advice__title">{{ adviceLabel }}</h2>
      <p class="c-advice__sublabel" v-if="adviceSublabel"><strong>{{ adviceSublabel }}</strong></p>
      <p>{{ adviceText }}</p>
      <ul class="c-advice__links">
        <li class="c-advice__link" v-for="(link, index) in topic.links" :key="link.title">
          <a :href="link.url" target="_blank" v-if="!link.title">Interesssante link {{ index + 1 }}</a>
          <a :href="link.url" target="_blank" v-if="link.title">{{ link.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AdviceMixin from '../mixins/Advice'
import TopicCircle from './TopicCircle.vue'
export default {
  mixins:[AdviceMixin],
  components: {
    TopicCircle
  },
  props: {
    status: {
      type: Boolean
    },
    sizeCategory: {
      type: Number
    },
    noOpinion: {
      type: Boolean
    },
    topic: {
      required: true
    }
  },
  computed: {
    adviceText () {
      if (this.status === true) {
        return this.topic.advice.positive
      } else if (this.status === false) {
        return this.topic.advice.negative
      } else {
        return 'Onze Future Forward coaches geven u graag meer info tijdens een individueel begeleidingstraject.'
      }
    },
    adviceLabel () {
      return this.adviceLabelHelperFunction(this.sizeCategory, this.status);
    },
    adviceSublabel () {
      return this.adviceSublabelHelperFunction(this.sizeCategory, this.status);
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/variables.scss';

.c-advice {
  display: flex;
}

.c-advice__image {
  page-break-inside: avoid;
  flex: none;
  margin-right: 3.2rem;
  width: 22.4rem;

  .c-topic {
    margin: 0 auto;
  }
}

.c-advice__title {
  font-size: 2.2rem;
  font-weight: 600;
  margin-bottom: 1.6rem;
}

.c-advice__label {
  font-weight: 600;
  margin-top: 1.6rem;
  text-align: center;
  text-transform: uppercase;
}

.c-advice__text {
  flex: 1 1 auto;
}

.c-advice__link {
  display: block;

  a {
    display: block;
    padding: 0.4rem 1.6rem 1.2rem 0;
    position: relative;

    &:after {
      content: '→';
      position: absolute;
      right: 0;
    }
  }
}

@media screen and (max-width: $bp-medium) {
  .c-advice {
    flex-direction: column;
  }

  .c-advice__image {
    margin-bottom: 1.6rem;
    width: 100%;

    & > * {
      margin: 0 auto;
    }
  }

  .c-advice__label {
    margin-top: 2.4rem;
  }
}
</style>
